<template>
  <section class="policy-form">
    <!--    //家佣-->
    <endorse-housemaid-policy-form
      v-if="productId !== 11"
      ref="housemaid-policy-form"
      :form="formData"
      :isCancel="isCancel"
      :occData="occData"
      :isEndorsement="isEndorsement"
      :action="action"
      @submit="getHouseMaidData"
    />
    <template v-else>
      <lazy-dom>
        <el-form
          ref="form"
          :rules="rules"
          :model="resultForm">
          <div class="form-item form-half">
            <span>{{isCancel?'Cancellation':'Endorsement'}} Effective Date</span>
            <v-date-picker
              v-if="isCancel"
              v-model="resultForm.pcy_expry_dt"
              :picker-options="pickerOptions" />
            <v-datetime-picker
              v-else
              v-model="resultForm.pcy_cmnt_dt"
              :picker-options="pickerOptions"/>
          </div>
          <template v-if="isEndorsement">
            <div class="form-item form-half">
              <span>Cover Note Effective Days</span>
              <el-form-item
                ref="pcy_cmnt_dt"
                prop="pcy_cmnt_dt">
                <v-select
                  v-model="resultForm.cvr_nt_isrd_days"
                  :list="cvr_nt_isrd_days"
                  @change="handleChangeCvrDays"
                />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Cover Note Expiry Date</span>
              <v-date-picker
                v-model="resultForm.cvr_nt_expry_dt "
                disabled />
            </div>
          </template>
          <div
            v-if="!isMotorTrade&&!isHzmb"
            class="form-item form-half">
            <span>Coverage</span>
            <el-form-item
            >
              <v-radio-group
                v-model="resultForm.trm_of_cvr"
                disabled
                :button="true"
                :list="allCoverTypeOptions" />
            </el-form-item>
          </div>
          <template v-if="isMotorTrade">
            <div class="form-item">
              <span>Type of insurance</span>
              <el-form-item
                :rules="rules.select"
                prop="type_of_ins">
                <v-radio-group
                  v-model="resultForm.type_of_ins"
                  :button="true"
                  disabled
                  :list="allOptions13.type_of_ins" />
              </el-form-item>
            </div>
            <div
              v-if="formData.type_of_ins == 2"
              class="form-item">
              <span>Number of Named Driver(s)</span>
              <el-form-item
                :rules="rules.no_of_nm_drvr"
                prop="no_of_nm_drvr">
                <v-radio-group
                  v-model="resultForm.no_of_nm_drvr"
                  :button="true"
                  disabled
                  :list="numberFourOptions"
                />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>No Claims in the past 3 years?</span>
              <el-form-item
                :rules="rules.select"
                prop="no_claim_3_year">
                <v-radio-group
                  v-model="resultForm.no_claim_3_year"
                  :border="true"
                  :list="yesNoOptions"
                />
              </el-form-item>
            </div>
          </template>
          <section
            v-if="formData.class_id !== 14&&!isMotorTrade"
            :class="{ 'mask-container': isCancel }">
            <div class="flex-sb">
              <div class="form-half">
                <div
                  v-if="!isHzmb"
                  class="form-item">
                  <span>Insurance Type</span>
                  <el-form-item
                    ref="trm_of_cvr"
                    prop="trm_of_cvr">
                    <v-select
                      v-model="resultForm.trm_of_cvr"
                      :list="coverTypeOptions"
                      @change="changeInsurance" />
                  </el-form-item>
                </div>
                <div
                  v-if="formData.trm_of_cvr != 1||isHzmb"
                  class="form-item">
                  <span>Hire Purchase Owner</span>
                  <el-form-item >
                    <v-radio-group
                      v-model="resultForm.hp_ind"
                      :border="true"
                      :list="yesNoOptions" />
                  </el-form-item>
                </div>
              </div>
              <div class="form-half">
                <div
                  v-if="formData.trm_of_cvr != 1&&!isHzmb"
                  class="form-item">
                  <span>Sum Insured</span>
                  <el-form-item
                    ref="isrd_vl"
                    prop="isrd_vl">
                    <v-input
                      v-model="resultForm.isrd_vl"
                      append="HK$" />
                  </el-form-item>
                </div>
                <!--                <div-->
                <!--                  v-if="formData.trm_of_cvr != 1 && formData.hp_ind == 1"-->
                <!--                  class="form-item">-->
                <!--                  <span>Name of Hire Purchase Owner (If Yes for Hire purchase)</span>-->
                <!--                  <el-form-item-->
                <!--                    ref="mortgagor"-->
                <!--                    prop="mortgagor">-->
                <!--                    <v-select-->
                <!--                      v-model="resultForm.mortgagor"-->
                <!--                      :list="localAllOptions.mortgagor" />-->
                <!--                  </el-form-item>-->
                <!--                </div>-->
                <div
                  v-if="(formData.trm_of_cvr != 1||isHzmb) && resultForm.hp_ind == 1"
                  class="form-item">
                  <span>Name of Hire Purchase Owner (If Yes for Hire purchase)</span>
                  <el-form-item
                    ref="mortgagor"
                    prop="mortgagor">
                    <v-select
                      v-model="resultForm.mortgagor"
                      :list="mortgagorOption" />
                  </el-form-item>
                  <el-form-item
                    v-if="isMortgagorOther"
                    ref="mortgagor_other"
                    class="margin-top-ten"
                    prop="mortgagor_other">
                    <v-input
                      v-model="resultForm.mortgagor_other"
                    />
                  </el-form-item>
                </div>
              </div>
            </div>
          </section>
          <div
            v-if="benefitList.length>0&&!isMotorTrade"
            class="box">
            <!--          <h2>Insured Items</h2>-->
            <div
              class="form-item form-half extra_checkbox">
              <span>Insured Items</span>
              <el-form-item
              >
                <v-checkbox-group
                  v-model="resultForm.benefits"
                  :list="benefitList"
                />
              </el-form-item>
            </div>
          </div>
          <div
            v-if="formData.class_id == 11 && extrabenefitsList.length>0"
            class="form-item form-half extra_checkbox">
            <span>Extra Benefits</span>
            <v-checkbox-group
              v-model="resultForm.extra_benefits"
              :button="true"
              :list="extrabenefitsList"
            />
          </div>
          <section :class="{ 'mask-container': isCancel }">
            <!--            <h2>Car Detail</h2>-->
            <template v-if="!isMotorTrade">
              <insured-vehicle-form
                ref="insured-vehicle-form"
                :formDataLock="formDataLock"
                :form="formData"
                :disabledList="disabledList"
                :is-endorsement="isEndorsement"
                :usage-ind.sync="formData.usage_ind"
                @getFormData="getSubFormData"
                @handleModel="handleModel"
                @handleInd="handleInd"
                @already-owned='handleAlreadyOwned'
              />
            </template>
            <h2>Policyholder</h2>
            <policy-holder-form
              ref="policy-holder"
              :formDataLock="formDataLock"
              :form="formData"
              :is-t-plate="isTPlate"
              @one-driver="(status) => policyOneDriver = status"
              @change-driver="handlerPolicyDriverInfo"
              @getFormData="getSubFormData"
              @confirm="handlerConfirmChangeInfo" />
            <template v-if="!isMotorTrade||isMotorTrade&&!isTPlate">
              <h2>Named Driver Information</h2>
              <drivers-base-info-form
                ref="drivers-base-info-form"
                :formDataLock="formDataLock"
                :form="formData"
                :orderId="orderId"
                :policyOneDriver="policyOneDriver"
                @getFormData="getSubFormData"
                @upload-file="uploadDriversFile"
                @change-policy-file="handlerDriverPolicyFile"
                @open-driver="handlerOpenDriver" />
            </template>

            <h2>Documents</h2>
            <document-form
              ref="document-form"
              :formDataLock="formDataLock"
              :form="formData"
              :currentDriversData="currentDriversData"
              @upload-file="handlerUploadCardFile"
              @delete-card-file="handlerDeleteCardFile" />
          </section>
        </el-form>
      </lazy-dom>
    </template>
  </section>
</template>
<script>
import InsuredVehicleForm from '@/views/components/insured-vehicle-form'
import PolicyHolderForm from '@/views/components/policy-holder-form'
import DriversBaseInfoForm from '@/views/components/drivers-base-info-form'
import DocumentForm from '@/views/tickets/components/document-form'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import EndorseHousemaidPolicyForm from '../modules/housemaid/endorse-housemaid-policy-form'
import {mapState} from 'vuex'
import dayjs from 'dayjs'

export default {
  name: 'PolicyForm',
  components: {
    InsuredVehicleForm,
    PolicyHolderForm,
    DriversBaseInfoForm,
    DocumentForm,
    EndorseHousemaidPolicyForm
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    action:{
      type: [String, Number],
      default: 0 //0正常 1 - endorse, 2 - cancel
    },
    form: {
      type: Object,
      default: () => ({})
    },
    occData: {
      type: Object,
      default: () => ({})
    },
    disabledList: {
      type: Array,
      default: () => ([])
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
      policyOneDriver: false, // 投保人關聯第一名記名司機
      currentDriversData: [],
      formData: {
        // date: [],
        // pcy_cmnt_dt: ''
        pcy_expry_dt: '',
        pcy_cmnt_dt: '',
        already_owned_by_ind: '',
        benefits:[],
        extra_benefits:[],
        no_of_nm_drvr:'',
        type_of_ins:'',
        no_claim_3_year:'',
      },
      resultForm: {
        // pcy_cmnt_dt: ''
        pcy_expry_dt: '',
        pcy_cmnt_dt: '',
        updDefInfo: [],
        mortgagor_other:'',
        cvr_nt_expry_dt: '',
        cvr_nt_isrd_days : '',
      },
      subForm: {
        'insured-vehicle-form': false,
        'policy-holder': false,
        'drivers-base-info-form': false
      },
      pickerOptions: {
        disabledDate(time){
          return time.getTime()<Date.now()
        }
      }
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    extrabenefitsList() {
      let benefits = this.allOptions11.extra_benefits || []
      // benefits = benefits.filter(item=>item.is_enabled==1)
      return benefits||[]
    },
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      kyc_benefit.some(item=>{
        // if(item.is_selected==1)
        //   this.formData.benefits.push(item.id)
        if(item.is_show!==0){
          arr.push({name:item.name,id:item.id})
        }
      })
      return arr||[]
    },
    orderId() {
      return this.form.id
    },
    classId(){
      return this.form.class_id
    },
    isHzmb(){
      return this.classId==15
    },
    //todo
    localAllOptions() {
      return this.allOptions
    },
    localOptions() {
      if (this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`] || { mortgagor: [] }
      }
    },
    mortgagorOption() {
      // 拿status 為1的數據
      let { mortgagor=[] } = this.localOptions
      if(mortgagor.length) {
        mortgagor = mortgagor.filter(e=>e.status)
      }
      return mortgagor
    },
    isMortgagorOther(){
      let {mortgagor}=this.resultForm||{}
      let list = this.mortgagorOption.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    isMotorTrade(){
      let {class_id} = this.form||{}
      return class_id ==13
    },
    isTPlate(){
      let {type_of_ins} = this.form||{}
      return type_of_ins ==1
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        let params = Object.assign(this.formData, val)
        // const { period_start = '', period_end = '' } = val
        // params = {
        //   ...params,
        //   date: [
        //     period_start,
        //     period_end
        //   ]
        // }
        this.formDataLock += 1
        this.formData = JSON.parse(JSON.stringify(params))
        let {quote_coverage_list} = this.formData||{}
        let {kyc_benefit=[]} = quote_coverage_list||{}
        kyc_benefit.some(item=>{
          if(item.is_selected==1)
            this.formData.benefits.push(item.id)
        })
        this.resultForm.pcy_expry_dt = val.pcy_expry_dt
        let date = new Date(this.formData.pcy_expry_dt).getTime()
        let dateCmnt = new Date(this.formData.pcy_cmnt_dt).getTime()

        if(date<Date.now())
        {
          this.formData.pcy_expry_dt =''
        }
        if(dateCmnt<Date.now())
        {
          this.formData.pcy_cmnt_dt =''
        }
        let {hp_ind=0,class_id} = this.formData||{}
        this.formData.hp_ind = hp_ind
        this.resultForm = JSON.parse(JSON.stringify(params))
        if(class_id==11){
          this.handlerExtraData()
        }
      }
    },
    'resultForm.benefits':{
      immediate:true,
      handler(val = [], old=[]) {
        if([11, 12].includes(Number(this.formData.class_id))) {
          const arr = this.formData.class_id == 11?
            [256, 512]:
            [4, 8, 16]
          // 新增才需要考慮
          if(val.length > old.length) {
            // 判斷有多少個是衝突的
            const filterList = val.filter(item => arr.includes(item))
            if(filterList.length > 1) {
              let flag = false
              const result = val.reduce((result, item) => {
                if(arr.includes(item) && !flag) {
                  flag = true
                  return result
                }
                result.push(item)
                return result
              }, [])
              this.resultForm.benefits = JSON.parse(JSON.stringify(result))
            }
          }
        }
      }
    },
  },
  methods: {
    handleChangeCvrDays(){
      let {pcy_cmnt_dt,cvr_nt_isrd_days} = this.resultForm||{}
      let day = dayjs(pcy_cmnt_dt).add(cvr_nt_isrd_days,'day').format('YYYY-MM-DD 23:59:59')
      this.resultForm.cvr_nt_expry_dt = day
    },
    changeInsurance(){
      this.handlerExtraData()
    },
    handlerExtraData(){
      let {class_id,model_id, nm_drvr_list, enough_age_ind,enough_exp_ind,rgtn_yr} = this.quoteForm||{}
      if(class_id==11)
      {
        let {trm_of_cvr = []} = this.filterData||{}
        this.updateExtraOptions({trm_of_cvr,class_id,model_id,nm_drvr_list,rgtn_yr,enough_age_ind,enough_exp_ind})
      }
    },
    handleModel(model_id){
      let {class_id, nm_drvr_list, enough_age_ind,enough_exp_ind,rgtn_yr} = this.quoteForm||{}
      this.formData.model_id = model_id
      if(class_id==11)
      {
        let {trm_of_cvr = []} = this.filterData||{}
        this.updateExtraOptions({trm_of_cvr,class_id,model_id,nm_drvr_list,rgtn_yr,enough_age_ind,enough_exp_ind})
      }
    },
    handleInd(params){
      Object.assign(this.formData,params)
      let obj = JSON.parse(JSON.stringify(this.formData))
      this.formData = obj
    },
    handleAlreadyOwned(val){
      this.formData.already_owned_by_ind = val
    },
    async submitForm() {
      if(this.productId != 11) {
        await this.$refs['housemaid-policy-form'].submitForm()
        return true
      }

      if(this.isCancel) {
        // 校驗 pcy_expry_dt, pcy_cmnt_dt
        this.$emit('submit', this.resultForm)
        return
      }
      // 表單校驗
      if(!this.handler().validateForm()) {
        return
      }
      // 獲取文件數據
      const documentParams = await this.$refs['document-form'].submitForm()
      if(!documentParams) return

      this.resultForm = Object.assign(this.resultForm, documentParams)
      if(this.isMotorTrade&&this.isTPlate){
        this.resultForm.nm_drvr_list = []
      }
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          // this.resultForm = {
          //   ...this.resultForm,
          // pcy_cmnt_dt: this.formData.pcy_cmnt_dt
          // period_start: this.formData.date[0],
          // period_end: this.formData.date[1]
          // }
          // 判斷是否要同步投保人資料
          const { updDefInfo } = this.resultForm
          if(updDefInfo && updDefInfo.length > 0) {
            // if(this.resultForm.isUpdatePolicyData === 1) {
            this.$refs['policy-holder'].openConfirmDialog()
          }
          else {
            this.$emit('submit', this.resultForm)
          }
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
    },
    // 获取到家政信息
    getHouseMaidData(data){
      this.resultForm = Object.assign(this.resultForm, data)
      this.$emit('submit', this.resultForm)
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.resultForm = Object.assign(this.resultForm, data)
    },
    // 投保人資料關聯幾名司機
    handlerPolicyDriverInfo(data) {
      const id_type_pic = this.$refs['document-form'].getCardFileData()
      const result = {
        ...data,
        id_type_pic
      }
      this.$refs['drivers-base-info-form'].handlerPolicyDriverInfo(result)
    },
    handlerDriverPolicyFile(data) {
      this.$refs['document-form'].updatePolicyFile(data)
    },
    handlerUploadCardFile(data) {
      if(this.policyOneDriver) {
        this.$refs['drivers-base-info-form'].updateOnePolicyFile(data)
      }
    },
    handlerDeleteCardFile() {
      if(this.policyOneDriver) {
        this.$refs['drivers-base-info-form'].deleteOnePolicyFile()
      }
    },
    // 更新司機文件數據
    uploadDriversFile(data) {
      // const { index, type, name, id } = data
      this.$refs['document-form'].updateDriversFile(data)
    },
    handlerConfirmChangeInfo(result) {
      if(result) {
        this.resultForm.upd_def_addr = 1
      }
      // 傳遞數據
      this.$emit('submit', this.resultForm)
    },
    // 記名司機同步
    handlerOpenDriver(data, list) {
      this.currentDriversData = data
    },
    handler() {
      return {
        validateForm: () => {
          if(this.isMotorTrade){
            delete this.subForm['insured-vehicle-form']
            if(this.isTPlate)
              delete this.subForm['drivers-base-info-form']
          }
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if (Object.values(this.subForm).some(item => item === false)) {
            return false
          }
          return true
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    .margin-top-ten{
      margin-top: 10px;
    }
    .extra_checkbox{
      ::v-deep .el-checkbox-group{
        flex-direction: column;
        align-items: flex-start;
      }
    }
</style>
